module.exports = __webpack_public_path__ + "static/img/07007C_2_3_R_20201106_fit.02dd22a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/07007C_2_3_R_20201106_fit.png
// module id = ae1d
// module chunks = 0